<div class="test-wrap">
  <p>Введите вопрос, на который хотите получить развернутый ответ</p>
  <div class="content">
    <angular-tiptap-editor
      [content]="question"
      [config]="editorConfig"
      (contentChange)="onQuestionChange($event)"
      />

    <a class="delete" (click)="DeleteTest()">
      <img src="assets/icons/blocks/delete.svg">
    </a>
  </div>
  <div class="input-wrap--file">
    <p>Файл</p>
    @if (
      loadingService.States[
      loadingService.getIdFromArrayStateByType(
      loadingService.StatesNames.UPLOAD_TEST_FILE
      )
      ].value) {
      <app-preloader
      ></app-preloader>
    } @else {
      @if (!FileName) {
        <div class="file-wrapper--button"
          (click)="$event.stopPropagation()">
          <input
            [id]="'file'+id"
            type="file"
            (change)="UploadFile($event.target)"
            >
          <label [for]="'file'+id" class="label-file">
            <div class="label-content">
              <img src="assets/icons/download.svg"> Загрузить файл
            </div>
          </label>
        </div>
      }
    }
    @if (
      DownloadId===id && loadingService.States[
      loadingService.getIdFromArrayStateByType(
      loadingService.StatesNames.TEST_FILE
      )
      ].value) {
      <app-preloader
      ></app-preloader>
    } @else {
      @if (FileName) {
        <div class="file-preview">
          <button type="button" class="btn-custom  btn-active"
            (click)="DownloadFile()">
            {{FileName||'Скачать файл'}}
          </button>
          <a type="button" (click)="DeleteFile()"><img src="assets/icons/delete.svg"></a>
        </div>
      }
    }
  </div>


</div>

